import Insurer_Minimal from './Insurer_Minimal'

export default {
    Insurer_Minimal,
}
